// tdsRates.js
export const TDS_RATES = {
    "192A": {
      name: "Premature withdrawal from EPF",
      baseRate: 10,
      noPanRate: 30,
      applicableTo: ["Individual/HUF/Sole Proprietor"],
    },
    "193": {
      name: "Interest on securities",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194": {
      name: "Dividend/Deemed dividend to a resident",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194A": {
      name: "Interest other than securities",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194B": {
      name: "Winning from lottery or crossword puzzle",
      baseRate: 30,
      noPanRate: 30,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194BA": {
      name: "Winning from Online gaming",
      baseRate: 30,
      noPanRate: 30,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194BB": {
      name: "Winning from Horse races",
      baseRate: 30,
      noPanRate: 30,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194C": {
      name: "Payment to contractor/sub-contractor",
      baseRate: 2,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194D": {
      name: "Insurance commission",
      baseRate: 5,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194DA": {
      name: "Payment in respect of life insurance policy",
      baseRate: 5,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194EE": {
      name: "Payment in respect of deposits under National Savings Scheme, 1987",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194F": {
      name: "Payment on account of repurchase of units of MF or UTI",
      baseRate: 20,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194G": {
      name: "Commission on sale of lottery tickets",
      baseRate: 5,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194H": {
      name: "Commission or brokerage",
      baseRate: 5,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194I(a)": {
      name: "Rent (Plant and Machinery)",
      baseRate: 2,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194I(b)": {
      name: "Rent (Others)",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194IA": {
      name: "Payment/credit of consideration for transfer of immovable property",
      baseRate: 1,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194IB": {
      name: "Payment/credit of rent by Individual/HUF to a resident",
      baseRate: 5,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194IC": {
      name: "Payment under joint development agreement",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194J": {
      name: "Fees for professional or technical services",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194K": {
      name: "Payment of Income to specified unit-holders",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194LA": {
      name: "Payment of compensation on acquisition of immovable property",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194LBA(1)": {
      name: "Income from units of a business trust",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194LBB": {
      name: "Payment in respect of units of investment fund",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194LBC": {
      name: "Income from investment in specified securitization trust",
      baseRate: 10,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    "194M": {
      name: "TDS on account of contractual work, brokerage, and professional fees",
      baseRate: 5,
      noPanRate: 20,
      applicableTo: ["Individual/HUF/Sole Proprietor", "Others"],
    },
    // "194T": {
    //   name: "Payment to partners",
    //   baseRate: 10,
    //   noPanRate: 10,
    //   applicableTo: ["Firm"],
    // },
  };
  